import {NumericTextBox as KendoNumericTextBox} from '@progress/kendo-react-inputs';
import KendoHOC from "./utils/KendoHOC";

const NumericTextBox = (options) => (KendoHOC(KendoNumericTextBox, options));

export default NumericTextBox;
